webpackJsonp([3],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_Auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailModal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_AppConfig__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__legacy_helper__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var Login = function () {
    /**
     *
     * @param ssoLoginUri : Function that should return a SSO login URI
     * (socialId) => {}
     * @param ssoLoginDataFeed : Function that should return data to pass to SSO login API
     * (userId, accessToken) => {}
     */
    function Login(ssoLoginUri, ssoLoginDataFeed) {
        var _this = this;

        _classCallCheck(this, Login);

        this.onGoogleSignIn = function (googleUser) {
            var accessToken = googleUser.getAuthResponse().id_token,
                userId = googleUser.getBasicProfile().getId();

            _this.ssoLogin("google", userId, accessToken);
        };

        this.onFacebookSignIn = function (loginResponse) {
            if (loginResponse.status === 'connected' && loginResponse.authResponse && loginResponse.authResponse.accessToken && loginResponse.authResponse.userID) {
                _this.ssoLogin("facebook", loginResponse.authResponse.userID, loginResponse.authResponse.accessToken);
            }
        };

        this.googleLogin = function () {
            window.gapi.auth2.getAuthInstance().signIn().then(_this.onGoogleSignIn);
        };

        this.facebookLogin = function () {
            window.FB.login(_this.onFacebookSignIn, { scope: __WEBPACK_IMPORTED_MODULE_2_AppConfig__["a" /* default */].facebookPermissions });
        };

        this.ssoLogin = function (socialId, userId, accessToken, email, lastName) {
            $.ajax({
                type: 'POST',
                url: _this.ssoLoginUri(socialId),
                // Always include an `X-Requested-With` header in every AJAX request,
                // to protect against CSRF attacks.
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(_this.ssoLoginDataFeed(userId, accessToken, email, lastName))
            }).done(Login.redirectAfterLogin).fail(function (response) {
                var isEmailMissing = response && response.responseJSON && response.responseJSON.isEmailMissing;
                var isLastNameMissing = response && response.responseJSON && response.responseJSON.isLastNameMissing;
                if (isEmailMissing || isLastNameMissing) {
                    // Special case : user successfully logged in, but social network is not giving back user email
                    // Display a modal to ask user's email
                    if (!_this.emailModal) {
                        _this.emailModal = new __WEBPACK_IMPORTED_MODULE_1__EmailModal__["a" /* default */](socialId, userId, accessToken, _this.ssoLogin, isEmailMissing, isLastNameMissing);
                    }
                    _this.emailModal.show();
                } else {
                    Login.showErrorMessage(response);
                }
            });
        };

        this.initFacebookLoginButton = function () {
            return $(".facebook-btn").click(_this.facebookLogin);
        };

        this.initGoogleLoginButton = function () {
            return $(".google-btn").click(_this.googleLogin);
        };

        this.init = function () {
            // Load social APIs and initialize social buttons
            __WEBPACK_IMPORTED_MODULE_0__auth_Auth__["a" /* default */].loadGoogleAuthApi(_this.initGoogleLoginButton);
            __WEBPACK_IMPORTED_MODULE_0__auth_Auth__["a" /* default */].loadFacebookAuthApi(_this.initFacebookLoginButton);
        };

        this.ssoLoginUri = ssoLoginUri;
        this.ssoLoginDataFeed = ssoLoginDataFeed;
        this.emailModal = undefined;
    }

    /**
     * Will be called when user successfully logged in with Google.
     * It will call SSO with some information taken from Google
     * @param googleUser : GoogleUser (see https://developers.google.com/identity/sign-in/web/reference#googleusergetid)
     */


    /**
     * Will be called when user successfully logged in with Facebook.
     * It will call SSO with some information taken from Facebook
     * @param loginResponse : Facebook Login response (see https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus/)
     */


    /**
     * Will be called when user click on Google login button.
     */


    /**
     * Will be called when user click on Facebook login button.
     */


    /**
     * Will call SSO with minimal information coming from Google/Facebook
     * @param socialId
     * @param userId
     * @param accessToken
     * @param email (optional) : coming from Email modal
     * @param lastname (optional) : coming from Email modal
     */


    _createClass(Login, null, [{
        key: "redirectAfterLogin",
        value: function redirectAfterLogin(response) {
            if (response && response.redirectUri) {
                window.location.replace(response.redirectUri);
            }
        }
    }, {
        key: "showErrorMessage",
        value: function showErrorMessage(response) {
            if (response && response.responseJSON && response.responseJSON.error) {
                if (response.responseJSON.code === 190) {
                    $(".login-page-error__text").text(response.responseJSON.error);
                    setTimeout(function () {
                        window.location.reload();
                    }, 1500);
                } else response && response.responseJSON && response.responseJSON.error;
                {
                    $(".login-page-error__text").text(response.responseJSON.error);
                }
            } else {
                var defaultErrorMessage = "Sorry, das hätte nicht passieren dürfen. Bitte versuchen Sie es nochmal.";
                if (__WEBPACK_IMPORTED_MODULE_3__legacy_helper__["a" /* default */].getLang() === "en") defaultErrorMessage = "We're sorry, that shouldn't have happened. Please try again later.";

                $(".login-page-error__text").text(defaultErrorMessage); // TODO RCH : create translation files for frontend
            }
            $(".login-page-error").addClass("login-page-error--visible");
        }
    }]);

    return Login;
}();

/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_Modal__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__legacy_helper__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var modal = $("#email-modal"),
    form = $("#email-modal__form"),
    badEmailError = $("#email-modal__bad-email-error"),
    emailExistsError = $("#email-modal__email-exists-error"),
    badLastNameError = $("#email-modal__bad-lastname-error"),
    defaultError = $("#email-modal__default-error"),
    emailField = $("#accountEmail"),
    lastNameField = $("#accountLastName");

var EmailModal = function () {
    function EmailModal(socialId, userId, accessToken, ssoLoginCallback, isEmailMissing, isLastNameMissing) {
        var _this = this;

        _classCallCheck(this, EmailModal);

        this.submit = function () {
            // Continue account creation by passing social auth info + user's email and/or user's lastname
            if (!_this.checkLastName()) return;

            if (_this.isEmailMissing) {
                _this.checkEmail(function (email) {
                    return _this.ssoLoginCallback(_this.socialId, _this.userId, _this.accessToken, email, lastNameField.val());
                });
            } else {
                _this.ssoLoginCallback(_this.socialId, _this.userId, _this.accessToken, undefined, lastNameField.val());
            }
        };

        this.checkLastName = function () {
            // Hide previous errors
            badLastNameError.addClass("hide");

            if (_this.isLastNameMissing && !lastNameField.val().trim()) {
                badLastNameError.removeClass("hide");
                return false;
            } else {
                return true;
            }
        };

        this.checkEmail = function (cb) {
            // Hide previous errors
            emailExistsError.addClass("hide");
            defaultError.addClass("hide");
            badEmailError.addClass("hide");
            var email = emailField.val().toLowerCase();

            if (!__WEBPACK_IMPORTED_MODULE_2__legacy_helper__["a" /* default */].patterns().email.exec(email)) {
                badEmailError.removeClass("hide");
                return;
            }

            __WEBPACK_IMPORTED_MODULE_0__api_Api__["b" /* UserApi */].checkEmail(email).then(function (response) {
                if (response.alreadyExist) {
                    emailExistsError.removeClass("hide");
                } else {
                    cb(email);
                }
            }).fail(function () {
                defaultError.removeClass("hide");
            });
        };

        this.socialId = socialId;
        this.userId = userId;
        this.accessToken = accessToken;
        this.ssoLoginCallback = ssoLoginCallback;
        this.isEmailMissing = isEmailMissing;
        this.isLastNameMissing = isLastNameMissing;

        // Load and display Modal
        Object(__WEBPACK_IMPORTED_MODULE_1__modal_Modal__["a" /* default */])();

        // Display needed additional fields for account creation
        if (isEmailMissing) emailField.removeClass("hide");
        if (isLastNameMissing) lastNameField.removeClass("hide");
        form.submit(this.submit);
    }

    _createClass(EmailModal, [{
        key: "show",
        value: function show() {
            modal.addClass("modal--show");
        }
    }]);

    return EmailModal;
}();

/* harmony default export */ __webpack_exports__["a"] = (EmailModal);

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initModal;
/**
 * Scan all modals in the DOM, move them to the DOM top level and attach some code to them
 *
 * In order to create a Modal, you need to have DOM element with a "data-modal-for" attribute  which will references the id of the modal div.
 *
 * Example :
 *  <button data-modal-for="modal-id"></button>
 *  <div id="modal-id" class="modal"></div>
 */

function initModal() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";


    $(function () {

        // Move every modal in top level of the DOM to avoid z-index issue
        $(selector + " .modal").each(function (i, modal) {
            $(modal).appendTo(document.body);
        });

        // Show/hide logic
        $(selector + " [data-modal-for]").each(function (i, e) {

            function showModal(modal) {
                modal.addClass("modal--show");
                $("html").css("position", "absolute");
                $("html").css("left", "0");
                $("html").css("right", "0");
                $("html").css("margin", "auto");
                return false;
            }

            function hideModal(modal) {
                modal.removeClass("modal--show");
                $("html").css("position", "");
                $("html").css("left", "");
                $("html").css("right", "");
                $("html").css("margin", "");
                return false;
            }

            var modalId = $(e).attr("data-modal-for");
            var modal = $("#" + modalId); // Find modal according to "data-modal-for" attribute
            var modalBg = $(modal).find(".modal__bg");
            var closeButton = modal.find(".modal__inner__header__close");

            // Open modal handlers
            $(e).click(showModal.bind(this, modal));

            // Close modal handlers
            modalBg.click(hideModal.bind(this, modal));
            closeButton.click(hideModal.bind(this, modal));

            document.addEventListener("keydown", function (keyEvent) {
                if (keyEvent.which === 27) {
                    // Pressing "Escape" key
                    hideModal(modal);
                }
            });
        });
    });
}

window.initModal = initModal;

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Login__ = __webpack_require__(12);



new __WEBPACK_IMPORTED_MODULE_1__Login__["a" /* default */](function (socialId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_Api__["a" /* AuthApi */].socialLoginUri(socialId);
}, function (userId, accessToken, email, lastName) {
    return {
        userId: userId,
        accessToken: accessToken,
        email: email,
        lastName: lastName
    };
}).init();

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__ = __webpack_require__(4);


// TODO RCH : refactor by using sp-react-commons (first, we need to support passing headers like 'X-Requested-With' for each request)

var AuthApi = {
    logoutAllUri: function logoutAllUri(maybeRedirect) {
        return new __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__["a" /* default */]("/logoutAll").addQueryParam("redirectUri", maybeRedirect).build();
    },
    loginUri: "/login",
    oauthLoginUri: function oauthLoginUri(maybeLang) {
        var apiVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return new __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__["a" /* default */]("/sso/v" + apiVersion + "/login").addQueryParam("maybeLang", maybeLang).build();
    },
    socialLoginUri: function socialLoginUri(socialId) {
        var apiVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return "/sociallogin?apiVersion=" + apiVersion + "&socialId=" + socialId;
    },
    oauthSocialLoginUri: function oauthSocialLoginUri(socialId, maybeLang) {
        var apiVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return new __WEBPACK_IMPORTED_MODULE_0__utils_UriUtils__["a" /* default */]("/sso/v" + apiVersion + "/sociallogin?socialId=" + socialId).addQueryParam("maybeLang", maybeLang).build();
    }
};

var UserApi = {
    baseUrl: "/user/api/users",
    checkEmail: function checkEmail(email) {
        return $.ajax({
            type: 'GET',
            url: this.baseUrl + "/checkEmail?email=" + email,
            contentType: 'application/json',
            dataType: 'json'
        });
    }
};



/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UriUtils; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UriUtils = function () {
    function UriUtils(url) {
        _classCallCheck(this, UriUtils);

        this.url = url;
    }

    _createClass(UriUtils, [{
        key: 'addQueryParam',
        value: function addQueryParam(paramKey, paramValue) {
            if (paramValue) {
                if (this.url.indexOf("?") > -1) {
                    this.url += '&' + paramKey + '=' + paramValue;
                } else {
                    this.url += '?' + paramKey + '=' + paramValue;
                }
            }

            return this;
        }
    }, {
        key: 'getQueryParam',
        value: function getQueryParam(param) {
            // Seems to be the best way to extract a query parameter from url
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
            var results = regex.exec(this.url);

            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
    }, {
        key: 'build',
        value: function build() {
            return this.url;
        }
    }]);

    return UriUtils;
}();



/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    googleClientId: "1025537527851-gg2rrp3dm013vo6u5t1ck179sumtdspv.apps.googleusercontent.com",
    facebookAppId: "262131947223648",
    facebookApiVersion: "2.11",
    facebookPermissions: "public_profile,email"
});

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getLang: function getLang() {
        return $('html').attr('lang');
    },
    isSsl: function isSsl() {
        return location.protocol === 'https:';
    },
    patterns: function patterns() {
        return {
            email: /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
            name: /^[\u00c0-\u01ffa-zA-Z0-9 '_-]+$/
        };
    },
    getPasswordMinLength: function getPasswordMinLength() {
        return 8;
    }
});

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_AppConfig__ = __webpack_require__(5);


var Auth = {
    loadGoogleAuthApi: function loadGoogleAuthApi() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        // First, add meta needed for Google Auth API
        var googleClientId = document.createElement("meta");
        googleClientId.name = "google-signin-client_id";
        googleClientId.content = __WEBPACK_IMPORTED_MODULE_0_AppConfig__["a" /* default */].googleClientId;
        document.head.appendChild(googleClientId);

        // Then, dynamically load Google API
        // Attach a callback function that will be called when the library will be loaded
        window.onLoadGoogleAuthApi = function () {
            window.gapi.load('auth2', function () {
                window.gapi.auth2.init().then(callback);
            });
        };
        var googleApiScript = document.createElement("script");
        googleApiScript.src = "https://apis.google.com/js/platform.js?onload=onLoadGoogleAuthApi";
        googleApiScript.setAttribute('defer', '');
        googleApiScript.setAttribute('async', '');
        // Catch any exception while loading google script (Firefox private navigation mode is blocking this script)
        googleApiScript.onerror = function (error) {
            callback(error);
        };
        document.head.appendChild(googleApiScript);
    },
    loadFacebookAuthApi: function loadFacebookAuthApi() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        // Will be asynchronously called when Facebook SDK will be loaded
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: __WEBPACK_IMPORTED_MODULE_0_AppConfig__["a" /* default */].facebookAppId,
                cookie: true,
                xfbml: true,
                version: "v" + __WEBPACK_IMPORTED_MODULE_0_AppConfig__["a" /* default */].facebookApiVersion
            });

            callback();
        };

        // Load Facebook SDK
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            // Catch any exception while loading facebook script (Firefox private navigation mode is blocking this script)
            js.onerror = function (error) {
                callback(error);
            };
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ })

},[270]);


// WEBPACK FOOTER //
// javascripts/loginPage.js